<template>
    <fieldset class="form-fieldset grid grid__base" :class="bemFacets">
        <legend class="form-fieldset--label" v-if="name">
            {{ name }}
        </legend>
        <div class="form--field-row">
            <slot v-if="$slots.default"/>
            <component class="form--field"
                    v-for="(field, fieldIdx) in fields"
                    v-else
                    :key="fieldIdx"
                    :is="field.component"
                    v-bind="bindFieldProps(field)"
                    v-model="field.value"/>
        </div>
    </fieldset>
</template>

<script>
    import bemMixin from 'framework/mixins/bem/index';

    export default {
        mixins: [
            bemMixin('form-fieldset'),
        ],
        props: {
            bindFieldProps: {
                type: Function,
                required: true,
            },
            /** @type {IFormFieldAbstract} */
            fields: {
                type: Array,
                required: true,
            },
            name: {
                type: String,
                default: null,
            },
        },
    };
</script>
